/**
 * Shared sort-selection helper (Phase 2 review fix P4). `AllFiltersModal.handleSortSelect` used
 * to duplicate `SrpView.handleSortChange`'s URL rewrite verbatim (both wrote the same `?sort=`
 * search param and hard-navigated the same way); this is the one place that logic lives now.
 * Behaviour is unchanged from both call sites' original implementations: sets the sort in
 * SearchContext, then rewrites the URL so the choice is shareable/bookmarkable/refresh-safe ,
 * adds `?sort=<preference>` for a non-default sort, removes it for 'relevance', and strips any
 * legacy `[sort]`-bracketed query keys along the way.
 */
export type SortPreference = 'relevance' | 'date' | 'salary';

export function applySortPreference(
  preference: SortPreference,
  setSort: (preference: SortPreference) => void,
): void {
  setSort(preference);
  try {
    const url = typeof window !== 'undefined' ? new URL(window.location.href) : null;
    if (!url) return;
    const legacyKeys = Array.from(url.searchParams.keys()).filter((key) => key.includes('[sort]'));
    legacyKeys.forEach((key) => url.searchParams.delete(key));
    if (preference === 'relevance') {
      url.searchParams.delete('sort');
    } else {
      url.searchParams.set('sort', preference);
    }
    window.location.assign(url.toString());
  } catch {
    // no-op: sort was already updated in SearchContext above, only the URL sync failed.
  }
}
